import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';
import { ContextGraphVisualization } from '@/types/context-graph-types';

export const getContextGraphVisualization = async (
  graphId: string,
  limit = 250,
): Promise<ContextGraphVisualization> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;
  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  const response = await apiRequest<ContextGraphVisualization>({
    url: `/context-graphs/${orgId}/${graphId}/visualization?limit=${limit}`,
    method: 'GET',
    target: 'platform',
  });

  if (response.detail) {
    throw new Error(response.detail);
  }
  if (!response.data) {
    throw new Error('Unexpected response format');
  }
  return response.data;
};
